import Vue from 'vue'
import Router from 'vue-router'
import menuRoutes from './MenuRoutes'
// Import Guard
import guard from '@/routes/guard/guard'
import beforeEachGuards from './guard/beforeEach'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: menuRoutes,
})

// router.beforeEach((to, from, next) => {
//     let openCashDesk = store.state.AuthModule.openCashDesk
//     let { name } = to
//     if (
//         [
//             'CashDesk',
//             'customerPayment',
//             'customerPaymentVerify',
//             'CreditNote',
//         ].includes(name) &&
//         !openCashDesk
//     ) {
//         let route =
//             process.env.VUE_APP_API_ROUTE +
//             '/pos_daily_cash_initial_resume?pos_cash_desk_id=1'
//         axios
//             .get(route)
//             .then(r => {
//                 store.dispatch('AuthModule/setOpenCashDesk', true)
//                 next()
//                 return
//             })
//             .catch(e => {
//                 next('/movement')
//                 return
//             })
//     }
//     next()
// })

// Global guard for router ( redirect to Login if user is not authenticated)
router.beforeEach(guard)

beforeEachGuards.forEach(g => router.beforeEach(g))

export default router
